{
	"name": "chicken_coop",
	"size": [64, 32],
	"kit": "colony",
	"out": "items/farming/chicken_coop",
	"replaces": "tools/generate_chicken_coop_sprites.py",
	"frames": {
		"count": 8,
		"drive": "straw",
		"values": [0, 1, 0, 1, 0, 1, 0, 1],
		"drives": { "led": [1, 1, 0, 0, 1, 1, 0, 0] }
	},
	"parts": [
		{ "shape": "panel", "inset": [4, 10, 4, 5], "role": "wood" },
		{ "shape": "panel", "inset": [4, 10, 4, 20], "role": "wood_lit" },
		{ "shape": "panel", "inset": [4, 25, 4, 5], "role": "wood_dark" },
		{ "shape": "panel", "inset": [2, 5, 2, 21], "role": "roof" },
		{ "shape": "panel", "inset": [2, 5, 2, 26], "role": "roof_lit" },
		{ "shape": "panel", "inset": [4, 3, 4, 26], "role": "roof_lit" },
		{ "shape": "panel", "inset": [6, 2, 6, 28], "role": "roof" },
		{ "shape": "panel", "inset": [26, 14, 26, 6], "role": "casing_shadow" },
		{ "shape": "panel", "inset": [27, 14, 27, 17], "role": "casing" },
		{ "shape": "panel", "inset": [28, 22, 28, 6], "role": "straw_dark" },
		{ "shape": "mover", "from": [28, 21], "to": [28, 22], "value": "straw", "role": "straw" },
		{ "shape": "mover", "from": [30, 21], "to": [30, 22], "value": "straw", "role": "straw" },
		{ "shape": "mover", "from": [32, 21], "to": [32, 22], "value": "straw", "role": "straw" },
		{ "shape": "mover", "from": [34, 21], "to": [34, 22], "value": "straw", "role": "straw" },
		{ "shape": "panel", "inset": [8, 16, 44, 6], "role": "wood_dark" },
		{ "shape": "panel", "inset": [8, 16, 44, 15], "role": "wood" },
		{ "shape": "panel", "inset": [9, 18, 45, 7], "role": "straw_dark" },
		{ "shape": "rivets", "inset": [12, 20, 51, 11], "along": "top", "step": 1, "role": "straw" },
		{ "shape": "rivets", "inset": [15, 19, 48, 12], "along": "top", "step": 1, "role": "straw" },
		{ "shape": "panel", "inset": [44, 13, 6, 7], "role": "casing" },
		{ "shape": "panel", "inset": [44, 13, 6, 18], "role": "casing_lit" },
		{ "shape": "panel", "inset": [44, 24, 6, 7], "role": "casing_shadow" },
		{ "shape": "grille", "inset": [46, 16, 8, 9], "step": 2, "role": "casing_shadow" },
		{ "shape": "panel", "inset": [6, 26, 6, 5], "role": "trim_dark" },
		{
			"shape": "lamp",
			"at": [56, 7],
			"size": [1, 1],
			"value": "led",
			"thresholds": [0.5, 0.5],
			"roles": ["trim_dark", "trim_dark", "trim"],
			"highlight": false
		},
		{ "shape": "panel", "inset": [6, 27, 54, 2], "role": "casing_shadow" },
		{ "shape": "panel", "inset": [54, 27, 6, 2], "role": "casing_shadow" },
		{ "shape": "grille", "inset": [8, 12, 15, 7], "direction": "columns", "step": 8, "role": "wood_dark" }
	]
}
